import { Card } from "@blueprintjs/core";
import { Modal } from "components/notifications";
import OperatingLicenceMap from "./OperatingLicenceMap";
import './OperatingLicenceMap.css';
import PropTypes from "prop-types";

export function OperatingLicenceMapModal(
    {
        showMapModal = false,
        handleCloseMapModal = () => { },
        currentLicence = null,
        mapMarkers = [],
        trafficCommisioner = null,
        selectedOperatingCentreId = 0,
        clickMarkerHandler = () => { },
        operatingCentreOverviewText = "",
        operatingCentreTotalVehicles = 0,
        operatingCentreTotalTrailers = 0,
        operatingCentreAuthorisedVehicles = 0,
        operatingCentreAuthorisedTrailers = 0,
        operatingCentreNumberOfLocations = 0,
        operatingCentreAddress1 = "",
        operatingCentreAddress2 = "",
        operatingCentreAddress3 = ""
    }
) {
    return (
        <Modal
            className="operating-licence-map-modal"
            isOpen={showMapModal}
            fullScreen={true}
            onClose={handleCloseMapModal}
            size="superwide"
        >
            <div className="operating-licence-map-container">
                <OperatingLicenceMap
                    width="100%"
                    height="100%"
                    operatingLicenceArea={currentLicence.licenceArea}
                    mapMarkers={mapMarkers}
                    trafficCommisioner={trafficCommisioner}
                    selectedCentreId={selectedOperatingCentreId}
                    clickMarkerHandler={(id) => { clickMarkerHandler(id) }}
                />
            </div>
            <Card className="operating-centre-overview-section">
                <h6>OPERATING CENTRE</h6>
                <h2 className="operating-centre-overview-text">{operatingCentreOverviewText}</h2>
                <Card className="operating-centre-inner-card-style">
                    <div className="operating-centre-inner-card-kvp-container">
                        <div className="operating-centre-inner-card-kvp">
                            <h6>AUTHORISED VEHICLES</h6>
                            <div>{operatingCentreAuthorisedVehicles}/{operatingCentreTotalVehicles}</div>
                        </div>
                        <div className="operating-centre-inner-card-kvp">
                            <h6>AUTHORISED TRAILERS</h6>
                            <div>{operatingCentreAuthorisedTrailers}/{operatingCentreTotalTrailers}</div>
                        </div>
                        <div className="operating-centre-inner-card-kvp">
                            <h6>NUMBER OF LOCATIONS</h6>
                            <div>{operatingCentreNumberOfLocations}</div>
                        </div>
                        <div className="operating-centre-inner-card-kvp">
                            <h6>FULL ADDRESS</h6>
                            <div>{operatingCentreAddress1}</div>
                            <div>{operatingCentreAddress2}</div>
                            <div>{operatingCentreAddress3}</div>
                        </div>
                    </div>
                </Card>
            </Card>
        </Modal>
    );
}

export default OperatingLicenceMapModal;

OperatingLicenceMapModal.propTypes = {
    showMapModal: PropTypes.bool,
    handleCloseMapModal: PropTypes.func,
    currentLicence: PropTypes.object.isRequired,
    mapMarkers: PropTypes.array.isRequired,
    trafficCommisioner: PropTypes.object.isRequired,
    selectedOperatingCentreId: PropTypes.number.isRequired,
    clickMarkerHandler: PropTypes.func.isRequired,
    operatingCentreOverviewText: PropTypes.string.isRequired,
    operatingCentreTotalVehicles: PropTypes.number.isRequired,
    operatingCentreTotalTrailers: PropTypes.number.isRequired,
    operatingCentreAuthorisedVehicles: PropTypes.number.isRequired,
    operatingCentreAuthorisedTrailers: PropTypes.number.isRequired,
    operatingCentreNumberOfLocations: PropTypes.number.isRequired,
    operatingCentreAddress1: PropTypes.string.isRequired,
    operatingCentreAddress2: PropTypes.string.isRequired,
    operatingCentreAddress3: PropTypes.string.isRequired
}